const Spinner = ({ size = 16, color = "white" }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" className="animate-spin">
    <circle
      cx="25"
      cy="25"
      r="20"
      fill="none"
      stroke={color}
      strokeWidth="4"
      strokeDasharray="90 150"
      strokeLinecap="round"
    />
  </svg>
);
export default Spinner;
